import SectionTitle from "../../../../common/sectionTitle";
import Counter from "../../../../common/counter";

import aboutImageLeft from "../../../../assets/images/octopuses/left.png";
import aboutImageRight from "../../../../assets/images/octopuses/red-king.png";
import AboutInfoCardList from "../aboutInfoCardList";
import AboutStyleWrapper from "./About.style";

const About = () => {
  return (
    <AboutStyleWrapper className="v2_about_us_section" id="about">
      <div className="v2_about_overlay"></div>
      <div className="container">
        <SectionTitle
          className="text-center"
          isCenter={true}
          title="About Us"
          subtitle="THE STORY"
        />
        <div className="v2_about_us_content">
          <div className="v2_about_us_text">
            <p>
            The ALPHA OCTOPUS is a collection of 888 unique digital collectibles on the Ethereum blockchain.
            Your ALPHA OCTOPUS will double up as a member of the exclusive ALPHA OCTOPUS club where owners will be rewarded with perks and benefits. Not to mention the charitable causes associated with this project and its Amazing roadmap.
            </p>
            <p>
            ALPHA OCTOPUS is inspired by Lorde's Creation of Greatness where every successful person has to become like an ALPHA OCTOPUS to achieve Success. Many hands or tentacles make light work being able to multitask. Each NFT has unique traits with special utilities.
            </p>

            <div className="counter-wrap">
              <h4>
                To be minted <Counter end="888" />{" "}
              </h4>
              <h4>
                Attributes <Counter end="83" />
              </h4>
            </div>
          </div>
          <div className="v2_about_img v2_about_img_left">
            <span>
              <img src={aboutImageLeft} alt="ALPHA OCTOPUS nft about" />
            </span>
          </div>
          <div className="v2_about_img v2_about_img_right">
            <span>
              <img src={aboutImageRight} alt="ALPHA OCTOPUS nft thumb" />
            </span>
          </div>
        </div>

        {/* about card */}
        <AboutInfoCardList />
      </div>
    </AboutStyleWrapper>
  );
};

export default About;
